import { styled, Tooltip, tooltipClasses } from '@mui/material';
import { cardColors } from '../helpers/dashboardColors';

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: cardColors.bgColor,
        color: "#333",
        borderRadius: 8,
        fontSize: '16px',
        padding: "10px 12px",
        border: "1px solid #ddd",
        boxShadow: "0px 2px 10px rgba(0,0,0,0.08)",
    },
}));

export default LightTooltip;